const ACL = ({ isAllowed, children }) => {
  if (isAllowed) {
    return children
  } else {
    return null
  }
}

export default ACL
